import { render } from "./ModalClusterDelete.vue?vue&type=template&id=e840bf52&scoped=true&ts=true"
import script from "./ModalClusterDelete.vue?vue&type=script&lang=ts"
export * from "./ModalClusterDelete.vue?vue&type=script&lang=ts"

import "./ModalClusterDelete.vue?vue&type=style&index=0&id=e840bf52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e840bf52"]])

export default __exports__